/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Box, Checkbox, Divider, FormControl, FormControlLabel, Paper, TextField, Tooltip, CircularProgress } from '@mui/material';

import schemedefinationService from '../../../services/schemedefination.service';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';



const custom1 = ({
    value, options, handleOnChange,
    ...paperProps
}) => {
    const { children, ...restPaperProps } = paperProps;
    return (
        <Paper {...restPaperProps}>

            <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>

                <FormControlLabel
                    onClick={(e) => {
                        e.preventDefault(); // prevent blur

                        const allValues = options;

                        if (value?.length < allValues.length) {
                            // Select all items
                            handleOnChange(allValues);
                        } else {
                            // Unselect all items
                            handleOnChange([]);

                        }
                    }}
                    label={
                        <span style={{ fontSize: '13px', paddingLeft: '0.7em' }}>
                            {value?.length === options?.length ? 'Unselect All' : 'Select All'}
                        </span>
                    } control={
                        <Checkbox size='small' id="select-all-checkbox" checked={options.length > 0 && value?.length === options?.length} />
                    }
                />
            </Box>
            <Divider />
            {children}
        </Paper>
    );

}


const custom2 = ({
    fullData, classificationName, searchedValue, value, handleOnChange,
    ...paperProps
}) => {
    const { children, ...restPaperProps } = paperProps;

    const defaultValues = fullData[classificationName]?.DefaultValues || [];
    const displayKey = fullData[classificationName]?.DisplayExpr;
    const valueKey = fullData[classificationName]?.ValueExpr;

    // Normalize value to always be an array of objects
    const currentValue = (() => {
        if (!Array.isArray(value)) return [];

        // If value contains strings (IDs), convert to objects
        if (typeof value[0] === 'string') {
            return defaultValues.filter(item =>
                value.includes(item[valueKey])
            );
        }

        // If already objects, return as is
        return value;
    })();

    // Filtered options for search
    const filteredOptions = defaultValues.filter(item => {
        const displayVal = item[displayKey];
        return displayVal?.toLowerCase().includes(searchedValue.toLowerCase());
    });

    // Check if ALL filtered are selected
    const isAllFilteredSelected =
        filteredOptions.length > 0 &&
        filteredOptions.every(filtered =>
            currentValue.some(selected =>
                selected[valueKey] === filtered[valueKey]
            )
        );

    // Determine checkbox state
    const isAllSelected = searchedValue.length > 0
        ? isAllFilteredSelected
        : currentValue.length === defaultValues.length;

    const handleToggleClick = (e) => {
        e.preventDefault();

        if (searchedValue.length > 0) {
            if (isAllFilteredSelected) {
                // Unselect only filtered ones
                const newValues = currentValue.filter(
                    item => !filteredOptions.some(
                        filtered => filtered[valueKey] === item[valueKey]
                    )
                );
                handleOnChange(newValues);
            } else {
                // Select filtered without duplicates
                const mergedValues = [
                    ...currentValue,
                    ...filteredOptions.filter(
                        fo => !currentValue.some(cv => cv[valueKey] === fo[valueKey])
                    )
                ];
                handleOnChange(mergedValues);
            }
        } else {
            // Toggle Select All / Unselect All
            // eslint-disable-next-line no-lonely-if
            if (currentValue.length < defaultValues.length) {
                handleOnChange(defaultValues);
            } else {
                handleOnChange([]);
            }
        }
    };

    return (
        <Paper {...restPaperProps}>
            <Box
                onMouseDown={(e) => e.preventDefault()}
                sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}
            >
                <FormControlLabel
                    onClick={handleToggleClick}
                    label={
                        <span style={{ fontSize: '13px' }}>
                            {searchedValue.length > 0
                                ? isAllFilteredSelected // NOSONAR
                                    ? 'Unselect filtered options'
                                    : 'Select filtered options'
                                : currentValue.length === defaultValues.length // NOSONAR
                                    ? 'Unselect All'
                                    : 'Select All'
                            }
                        </span>
                    }
                    control={
                        <Checkbox
                            size='small'
                            id="select-all-checkbox"
                            checked={isAllSelected}
                        />
                    }
                />
            </Box>
            <Divider />
            {children}
        </Paper>
    );
};




const DistributorValueEditor = ({ handleOnChange, value, field }) => {
    const [loading, setLoading] = useState(false);


    const [subClassificationData, setSubClassificationData] = useState({}); // NOSONAR
    const [fullData, setFullData] = useState({});
    const classificationName = field ? field.split('-')[1] : '';
    const [dataTypes, setDataTypes] = useState({});
    const [options, setOptions] = useState([]);
    const [searchedValue, setSearchedValue] = useState(''); // NOSONAR
    const [AutocompleteLoadingMap, setAutocompleteLoadingMap] = useState(new Map());



 ;











    useEffect(() => {
        const getFirstSubClassification = async () => {
            setLoading(true);
            try {
                const payload = {
                    filterApplicationOn: 'Distributor',
                    filterClassification: classificationName,
                    IsException: false,
                    SchemeId: 0,
                };


                if (classificationName === '') {
                    return;
                }


                const schemeDefinationInstance = await schemedefinationService;
                const response = await schemeDefinationInstance.GetSchemeFilterSubClassificationDistributor(payload);

                if (response.status === 200) {

                    

                    setFullData((prevData) => ({
                        ...prevData,
                        [classificationName]: response.data,
                    }))
                    setSubClassificationData((prevData) => ({
                        ...prevData,
                        [classificationName]: response.data?.DefaultValues,
                    }));

                    setDataTypes((prevData) => ({
                        ...prevData,
                        [classificationName]: response.data?.DataType || '',
                    }));

                    // Filter options based on selected value
                    try {
                       







                        const filteredOptions = response.data?.DefaultValues.filter(item => value?.includes(item[response.data?.ValueExpr]));
                        
                        setOptions(filteredOptions.length > 0 ? filteredOptions : []);
                    } catch (error_) {

                         console.log("err: ", error_);
                    }
                } 
            } catch (error) {

                  console.log('Error:', error);
            } finally {
                setLoading(false);
            }
        };

        getFirstSubClassification();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classificationName]); // Adding `value` to dependencies

    if (dataTypes[classificationName] === "Autocomplete") {
        return (
            <FormControl fullWidth>


                <Autocomplete
                    key={classificationName}
                    freeSolo
                    forcePopupIcon
                    multiple
                    disabled={classificationName === ''}
                    fullWidth
                    disableCloseOnSelect
                    options={classificationName !== '' ? (Array.isArray(options) ? options : []) : []} // Use filtered options
                    getOptionLabel={(option) => {
                        const labelKey = Object.keys(option).find(key => !key.toLowerCase().includes('id'));
                        return option[labelKey];
                    }}
                    value={(Array.isArray(value) && typeof value[0] === 'string' && fullData[classificationName] ? fullData[classificationName]?.DefaultValues?.filter(item => {
                        const idKey = Object.keys(item).find(key => key.toLowerCase().includes('id' || 'Id'));

                        return idKey && value?.includes(item[idKey]);
                    }) : value) || []}
                    defaultValue={value ? options.filter(option => {
                        const idKey = Object.keys(option).find(key => key.toLowerCase().includes('id'));
                        return idKey && value?.includes(option[idKey]);
                    }) : []}
                    onChange={(event, newValue, reason) => {
                        if (!(reason === 'removeOption' && event.type === 'keydown')) {

                            handleOnChange(newValue);



                        }


                    }}
                    renderTags={(selected) => (
                        <span style={{ paddingLeft: '8px', fontSize: '13px' }}>
                            {selected.length === 1 ? `${selected.length} item selected` : `${selected.length} items selected`}
                        </span>
                    )}
                    slots={{
                        paper: custom1,
                    }}
                    slotProps={{
                        paper: {
                            options,
                            handleOnChange,
                            value,
                        },
                    }}
                    PaperComponent={custom1}
                    loading={AutocompleteLoadingMap.get(fullData[classificationName]?.ValueExpr)}
                    renderInput={(params) => (
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        maxHeight: '150px',
                                        overflowY: value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#9e9e9e',
                                            fontSize: '12px',
                                            fontWeight: '300',
                                        }}
                                    >
                                        {(Array.isArray(value) && typeof value[0] === 'string' && fullData[classificationName] ? fullData[classificationName]?.DefaultValues?.filter(item => {
                                            const idKey = Object.keys(item).find(key => key.toLowerCase().includes('id' || 'Id'));

                                            return idKey && value?.includes(item[idKey]);
                                        }) : value || []).map((item) => {
                                            const labelKey = Object.keys(item).find(key => !key.toLowerCase().includes('id'));
                                            return item[labelKey];
                                        }).join(', ') || 'No items selected'}
                                    </span>
                                </div>
                            }
                            arrow
                            placement="top"
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        backgroundColor: 'white', // White background
                                        color: 'black', // Black text
                                        border: '1px solid #ccc', // Optional: subtle border for better visibility
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: '#f9f9f9', // Match the arrow color with the tooltip background
                                    },
                                    display: value?.length === 0 || value === undefined || value === null ? 'none' : '', // Fix conditional syntax
                                },
                            }}
                        >



                            <TextField
                                {...params}
                                fullWidth
                                size="small"
                                label={`Select ${classificationName ? classificationName.toLowerCase() : ''}`.trim() || 'Select value'}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {AutocompleteLoadingMap.get(fullData[classificationName]?.ValueExpr) ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                                sx={{
                                    '& .MuiInputBase-input': {
                                        fontSize: '13px',  // Set text size to 13px
                                    },
                                    '& .MuiFormLabel-root': {
                                        fontSize: '14px',  // Set label text size to 14px
                                    },
                                }}
                            />

                        </Tooltip>
                    )}
                    onInputChange={async (event, newInputValue) => { // NOSONAR
                        if (newInputValue.length >= 3) {
                            setLoading(true);
                            try {
                                const schemeDefinationInstance = await schemedefinationService;
                                setAutocompleteLoadingMap(prev => new Map(prev).set(fullData[classificationName]?.ValueExpr, true));
                                const response = await schemeDefinationInstance.autocompleteSearchFilter(
                                    {
                                        "ControlId": `${fullData[classificationName]?.TableName}-${fullData[classificationName]?.DisplayExpr}`,
                                        "Values": newInputValue,
                                        /*  "IsStandard": false,
                                          "IsException": false, */
                                    }
                                );
                                setAutocompleteLoadingMap(prev => {
                                    const newMap = new Map(prev);
                                    newMap.delete(fullData[classificationName]?.ValueExpr);
                                    return newMap;
                                });
                                if (response.data && Array.isArray(response.data)) {
                                    setOptions(prevOptions => {

                                        let itemIdKey;
                                        if (prevOptions.length > 0) {
                                            itemIdKey = Object.keys(prevOptions[0]).find(key => key.toLowerCase().includes('id'));
                                        }
                                      

                                        // Step 4: Filter the selected options based on the value passed
                                        const selected = prevOptions.filter(item => value?.includes(item[itemIdKey]));


                                        const selectedIds = selected.map(item => item[itemIdKey]);

                                        // Step 2: Filter new options by checking if their IDs are not in the existingOptionIds Set
                                        const newOptions = response?.data?.filter(newItem => {
                                            // Extract the idKey for new data items
                                            const idKeyForNew = Object.keys(newItem).find(key => key.toLowerCase().includes('id'));
                                    
                                            return idKeyForNew && !selectedIds.includes(newItem[idKeyForNew]);
                                        });

                                   

                                        // Step 3: Get itemIdKey for the selected options if there are previous options

                                       

                                        // Step 5: Return the concatenation of the previous options and the filtered new ones
                                        return [...selected, ...newOptions];
                                    });



                                } else {
                                    console.error("Invalid response data: ", response);
                                    setAutocompleteLoadingMap(prev => {
                                        const newMap = new Map(prev);
                                        newMap.delete(fullData[classificationName]?.ValueExpr);
                                        return newMap;
                                    });

                                }
                            } catch (error_) {
                                 console.log(error_)
                            } finally {
                                setLoading(false)
                            }

                        }
                    }}
                    renderOption={(props, option, { selected }) => (

                        <li {...props} style={{ fontSize: '13px' }}>
                            <Checkbox
                                style={{ marginRight: 8 }}
                                checked={value?.includes(option[fullData[classificationName]?.ValueExpr]) || value?.includes(option)}
                                size='small'
                            />
                            {option[Object.keys(option).find(key => !key.toLowerCase().includes('id'))]}
                        </li>
                    )}
                    size="small"
                    sx={{
                        maxHeight: '35.69px'
                    }}
                />
            </FormControl>
        );
    }
    if (dataTypes[classificationName] === "MultiselectDropdown") {
    return (
        <FormControl fullWidth size='small'>
 
            <Autocomplete
                multiple
                key={classificationName}
                fullWidth
                size="small"
                disabled={classificationName === ''}
                value={(() => {
                    // If value is an array of strings (IDs), convert to objects
                    if (Array.isArray(value) && typeof value[0] === 'string' && fullData[classificationName]) {
                        return fullData[classificationName]?.DefaultValues?.filter(item => {
                            const idKey = Object.keys(item).find(key => key.toLowerCase().includes('id'));
                            return idKey && value.includes(item[idKey]);
                        }) || [];
                    }
                    // If value is already an array of objects, return as is
                    return value || [];
                })()}
                inputValue={searchedValue} // Match with the setter
                onInputChange={(event, newInputValue, reason) => {
                    if (reason === 'input') {
                        setSearchedValue(newInputValue);
                    }
                }}
                onChange={(event, newValue, reason) => {
                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                        handleOnChange(newValue);
                    }
                }}
                options={fullData[classificationName]?.DefaultValues || []}
                getOptionLabel={(option) => {
                    const label = Object.keys(option).find(key => !key.toLowerCase().includes('id'));
                    return option[label];
                }}
                isOptionEqualToValue={(option, valuee) => {
                    if (!option || !valuee) {
                        return false; // or handle the case where either is undefined/null
                    }
                    const valueKey = Object.keys(valuee).find(key => key.toLowerCase().includes('id'));
                    const optionKey = Object.keys(option).find(key => key.toLowerCase().includes('id'));
                    return valuee[valueKey] === option[optionKey];
                }}
                slots={{
                    paper: custom2,
                }}
                slotProps={{
                    paper: {
                        fullData, classificationName, searchedValue, value, handleOnChange,
                    },
                }}
                PaperComponent={custom2}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => {
                    const label = Object.keys(option).find(key => !key.toLowerCase().includes('id'));

                    return (
                        <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                            <Checkbox
                                checked={selected}
                                sx={{ fontSize: '13px' }}
                                size='small'
                            />
                            {option[label]}
                        </li>
                    );
                }}
                // onBlur={() => setSearchedValue('')}
                renderInput={(params) => (

                    <Tooltip
                        title={
                            <div
                                style={{
                                    maxHeight: '150px',
                                    overflowY: value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                }}
                            >
                                <span
                                    style={{
                                        color: '#9e9e9e',
                                        fontSize: '12px',
                                        fontWeight: '300',
                                    }}
                                >
                                    {(Array.isArray(value) && typeof value[0] === 'string' && fullData[classificationName] ? fullData[classificationName]?.DefaultValues?.filter(item => {
                                        const idKey = Object.keys(item).find(key => key.toLowerCase().includes('id' || 'Id'));

                                        return idKey && value?.includes(item[idKey]);
                                    }) : value || []).map((item) => {
                                        const labelKey = Object.keys(item).find(key => !key.toLowerCase().includes('id'));
                                        return item[labelKey];
                                    }).join(', ') || 'No items selected'}
                                </span>
                            </div>
                        }
                        arrow
                        placement="top"
                        PopperProps={{
                            sx: {
                                '& .MuiTooltip-tooltip': {
                                    backgroundColor: 'white', // White background
                                    color: 'black', // Black text
                                    border: '1px solid #ccc', // Optional: subtle border for better visibility
                                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                },
                                '& .MuiTooltip-arrow': {
                                    color: '#f9f9f9', // Match the arrow color with the tooltip background
                                },
                                display: value?.length === 0 || value === undefined || value === null ? 'none' : '', // Fix conditional syntax
                            },
                        }}
                    >


                        <TextField
                            {...params}
                            // placeholder="Select Value"
                            label={`Select ${classificationName ? classificationName.toLowerCase() : ''}`.trim() || 'Select value'}
                            // value={searchedValue}
                            // onChange={e => setSearchedValue(e.target.value)}
                            sx={{
                                '& .MuiInputBase-input': {
                                    fontSize: '13px',  // Set text size to 13px
                                },
                                '& .MuiFormLabel-root': {
                                    fontSize: '14px',  // Set label text size to 14px
                                },
                            }}
                        />
                    </Tooltip>
                )}
                renderTags={(selected, getTagProps) => {
                    const selectedCount = selected.length;
                    return (
                        <span style={{ fontSize: '13px', paddingLeft: '0.5em' }}>
                            {selectedCount === 1
                                ? `${selectedCount} item selected`
                                : `${selectedCount} items selected`}
                        </span>
                    );
                }}

                sx={{ fontSize: '13px' }}
                PaperProps={{
                    style: {
                        maxHeight: 200,
                        maxWidth: 250,
                    },
                }}
                ListboxProps={{
                    style: {
                        maxHeight: '224px',
                        '& .MuiAutocomplete-option': {
                            fontSize: '13px',  // Set the font size for the options
                        },
                    },
                }}
            />
            {
                loading && <LoadingProgressBar />
            }
        </FormControl>
    );
    }
    return <FormControl fullWidth size='small'>
        <TextField
            fullWidth
            size="small"
            label={`Enter ${classificationName ? classificationName.toLowerCase() : 'value'}`.trim() || 'Select value'}
            disabled={classificationName === '' || loading}
            placeholder="Select value"
            sx={{
                '& .MuiInputBase-input': {
                    fontSize: '13px',
                },
                '& .MuiFormLabel-root': {
                    fontSize: '14px',
                },
            }}
        />
        {loading && <LoadingProgressBar />}
    </FormControl>;
};

DistributorValueEditor.propTypes = {
    handleOnChange: PropTypes.func.isRequired,
    value: PropTypes.array,
    field: PropTypes.object.isRequired,
};

export default DistributorValueEditor;